import React, { useState, useEffect } from 'react';
import './Editable.css';

type editableType = {
	text: string;
	type: any;
	placeholder: string;
	children: any;
	childRef: any;
	className: string;
	textColor?: string;
};

const Editable = ({
	text,
	type,
	placeholder,
	children,
	childRef,
	className,
	textColor = 'text-gray-800',
	...props
}: editableType) => {
	const [isEditing, setEditing] = useState(false);

	useEffect(() => {
		if (childRef && childRef.current && isEditing === true) {
			childRef.current.focus();
		}
	}, [isEditing, childRef]);

	const handleKeyDown = (event: any, type: any) => {
		const { key } = event;
		const keys = ['Escape', 'Tab'];
		const enterKey = 'Enter';
		const allKeys = [...keys, enterKey];
		if (
			(type === 'textarea' && keys.indexOf(key) > -1) ||
			(type !== 'textarea' && allKeys.indexOf(key) > -1)
		) {
			setEditing(false);
		}
	};

	return (
		<section {...props}>
			{isEditing ? (
				<div
					onBlur={() => setEditing(false)}
					onKeyDown={(e) => handleKeyDown(e, type)}
				>
					{children}
				</div>
			) : (
				<div className={`${className}`} onClick={() => setEditing(true)}>
					<h3
						className={`${
							text ? textColor : 'text-gray-600 dark:text-gray-400 '
						}`}
					>
						{text || placeholder || 'Editable content'}
					</h3>
				</div>
			)}
		</section>
	);
};

export default Editable;
